import { render, staticRenderFns } from "./AboutAssociation.vue?vue&type=template&id=4bbf74a8&"
import script from "./AboutAssociation.vue?vue&type=script&lang=js&"
export * from "./AboutAssociation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports